export default __webpack_public_path__ + "static/media/portfolio5.2507c36f.png";